module.exports = __webpack_public_path__ + "error.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/error.png
// module id = 1898
// module chunks = 0